import { useRef } from "react";
import classNames from "classnames";
import { useIntersectionObserver } from "@react-hookz/web";
import { AnimatePresence, motion, useScroll } from "framer-motion";
import Portal from "util/Portal";
import { xPaddingClassName } from "../../../constants";

interface Props {
  children: React.ReactNode;
}

export default function FixedWhenScrolledMobileBar({ children }: Props) {
  const sensor = useRef<HTMLDivElement>(null);
  const intersection = useIntersectionObserver(sensor);
  const { scrollY } = useScroll();
  const showFixedBar =
    scrollY.get() > 0 && intersection?.isIntersecting === false;

  return (
    <>
      <div ref={sensor} />

      <Portal>
        <AnimatePresence>
          {showFixedBar && (
            <motion.div
              key="fixed-bar"
              className={classNames(
                "fixed inset-x-0 top-0 z-40 border-b-2 border-slate-300 bg-black px-2 font-brik text-sm md:hidden",
                xPaddingClassName
              )}
              transition={{ ease: "linear", duration: 0.05 }}
              initial={{ y: "-100%" }}
              animate={{ y: 0 }}
              exit={{ y: "-100%" }}
            >
              <div
                className={
                  "mx-auto max-w-4xl overflow-hidden text-ellipsis whitespace-nowrap text-white"
                }
              >
                {children}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </Portal>
    </>
  );
}
